import React, { useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { mockData } from '../utils/mockData';
interface AffidavitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
export const AffidavitModal = ({
  isOpen,
  onClose,
  onConfirm
}: AffidavitModalProps) => {
  const [isChecked, setIsChecked] = useState(false);
  const {
    title,
    declarations,
    confirmationText
  } = mockData.affidavit;
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-22">
      <div className="bg-[#1f1f1f] rounded-lg w-[600px] max-h-[90vh] overflow-y-auto border border-[#444444] mx-2" data-id="element-23">
        <div className="flex justify-between items-center p-4 border-b border-[#444444]" data-id="element-24">
          <h2 className="font-semibold text-lg" data-id="element-25">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-[#2a2a2a] rounded-lg transition-colors" data-id="element-26">
            <XIcon size={20} className="text-[#888888]" data-id="element-27" />
          </button>
        </div>
        <div className="p-6 space-y-6" data-id="element-28">
          <div className="space-y-4 text-sm leading-relaxed" data-id="element-29">
            <p data-id="element-30">I, the undersigned officer, do hereby declare and affirm:</p>
            <ol className="list-decimal ml-4 space-y-2 text-[#e0e0e0]" data-id="element-31">
              {declarations.map((declaration, index) => <li key={index} data-id="element-32">{declaration}</li>)}
            </ol>
          </div>
          <label className="flex items-center gap-3 p-4 bg-[#2a2a2a] rounded-lg cursor-pointer hover:bg-[#333333] transition-colors" data-id="element-33">
            <div className={`w-5 h-5 rounded border ${isChecked ? 'bg-[#4a90e2] border-[#4a90e2]' : 'border-[#444444]'} flex items-center justify-center transition-colors`} onClick={() => setIsChecked(!isChecked)} data-id="element-34">
              {isChecked && <CheckIcon size={14} className="text-white" data-id="element-35" />}
            </div>
            <span className="flex-grow" data-id="element-36">{confirmationText}</span>
          </label>
        </div>
        <div className="p-4 border-t border-[#444444] flex justify-end gap-3" data-id="element-37">
          <button onClick={onClose} className="px-4 py-2 bg-[#2a2a2a] text-[#e0e0e0] rounded-lg hover:bg-[#333333] transition-colors" data-id="element-38">
            Cancel
          </button>
          <button onClick={onConfirm} disabled={!isChecked} className={`px-4 py-2 rounded-lg transition-colors ${isChecked ? 'bg-[#4a90e2] text-white hover:bg-[#3a7bc2]' : 'bg-[#2a2a2a] text-[#666666] cursor-not-allowed'}`} data-id="element-39">
            Submit Report
          </button>
        </div>
      </div>
    </div>;
};